import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify"
import { getUserdetails, editProfile } from "../slice/workerEditProfile";

const WorkerEditProfile = () => {

    const stats = [
        { id: 1, code: 'AL', name: 'Alabama' },
        { id: 2, code: 'AK', name: 'Alaska' },
        { id: 3, code: 'AZ', name: 'Arizona' },
        { id: 4, code: 'AR', name: 'Arkansas' },
        { id: 5, code: 'CA', name: 'California' },
        { id: 6, code: 'CO', name: 'Colorado' },
        { id: 7, code: 'CT', name: 'Connecticut' },
        { id: 8, code: 'DE', name: 'Delaware' },
        { id: 9, code: 'FL', name: 'Florida' },
        { id: 10, code: 'GA', name: 'Georgia' },
        { id: 11, code: 'HI', name: 'Hawaii' },
        { id: 12, code: 'ID', name: 'Idaho' },
        { id: 13, code: 'IL', name: 'Illinois' },
        { id: 14, code: 'IN', name: 'Indiana' },
        { id: 15, code: 'IA', name: 'Iowa' },
        { id: 16, code: 'KS', name: 'Kansas' },
        { id: 17, code: 'KY', name: 'Kentucky' },
        { id: 18, code: 'LA', name: 'Louisiana' },
        { id: 19, code: 'ME', name: 'Maine' },
        { id: 20, code: 'MD', name: 'Maryland' },
        { id: 21, code: 'MA', name: 'Massachusetts' },
        { id: 22, code: 'MI', name: 'Michigan' },
        { id: 23, code: 'MN', name: 'Minnesota' },
        { id: 24, code: 'MS', name: 'Mississippi' },
        { id: 25, code: 'MO', name: 'Missouri' },
        { id: 26, code: 'MT', name: 'Montana' },
        { id: 27, code: 'NE', name: 'Nebraska' },
        { id: 28, code: 'NV', name: 'Nevada' },
        { id: 29, code: 'NH', name: 'New' },
        { id: 30, code: 'NJ', name: 'New' },
        { id: 31, code: 'NM', name: 'New' },
        { id: 32, code: 'NY', name: 'New' },
        { id: 33, code: 'NC', name: 'North' },
        { id: 34, code: 'ND', name: 'North' },
        { id: 35, code: 'OH', name: 'Ohio' },
        { id: 36, code: 'OK', name: 'Oklahoma' },
        { id: 37, code: 'OR', name: 'Oregon' },
        { id: 38, code: 'PA', name: 'Pennsylvania' },
        { id: 39, code: 'RI', name: 'Rhode' },
        { id: 40, code: 'SC', name: 'South' },
        { id: 41, code: 'SD', name: 'South' },
        { id: 42, code: 'TN', name: 'Tennessee' },
        { id: 43, code: 'TX', name: 'Texas' },
        { id: 44, code: 'UT', name: 'Utah' },
        { id: 45, code: 'VT', name: 'Vermont' },
        { id: 46, code: 'VA', name: 'Virginia' },
        { id: 47, code: 'WA', name: 'Washington' },
        { id: 48, code: 'WV', name: 'West' },
        { id: 49, code: 'WI', name: 'Wisconsin' },
        { id: 50, code: 'WY', name: 'Wyoming' },
    ];

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const fileInputRef = useRef(null);

    const [displayImage, setDisplayImage] = useState(null);
    const [originalProfileImage, setOriginalProfileImage] = useState(null);

    const [selectedBenefits, setSelectedBenefits] = useState([]);

    const { Userdetails, loading, error } = useSelector(
        (state) => state.workerEditProfile
    );

    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        date_of_birth: "",
        email: "",
        phone: "",
        employment_type: "",
        worker_type: "",
        teacher_position: "",
        support_position: "",
        states: "",
        benefit_enrollment_preferences: [],
        digital_signature_of_acknowledgment: "",
        business_name: "",
        ein: "",
        facility_type: "",
        staff_count: "",
        service_type: "",
        message: "",
        role_id: "",
    });

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'upload_verification_docs') {
            // If the user selects a new file, update formData and leave the displayImage unchanged
            setForm((prev) => ({
                ...prev,
                upload_verification_docs: files.length > 0 ? files[0] : prev.upload_verification_docs, // Store the File object
            }));
        } else {
            setForm({ ...form, [e.target.name]: e.target.value });
        }
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;

        if (checked) {
            // Add value if checked
            setSelectedBenefits((prev) => [...prev, value]);
        } else {
            // Remove value if unchecked
            setSelectedBenefits((prev) => prev.filter((v) => v !== value));
        }
    };

    useEffect(() => {
        if (!token) return;
        dispatch(getUserdetails(token));
    }, [token, dispatch]);

    const role_id = Userdetails?.user?.role_id;

    const isRole3 = role_id === 3;
    const isRole4 = role_id === 4;
    const isRole56 = role_id === 5 || role_id === 6;

    useEffect(() => {
        if (Userdetails?.user) {
            setForm({
                first_name: Userdetails.user.first_name ?? "",
                last_name: Userdetails.user.last_name ?? "",
                date_of_birth: Userdetails.user.date_of_birth ?? "",
                email: Userdetails.user.email ?? "",
                phone: Userdetails.user.phone ?? "",
                employment_type: Userdetails.user.employment_type ?? "",
                worker_type: Userdetails.user.worker_type ?? "",
                teacher_position: Userdetails.user.teacher_position ?? "",
                support_position: Userdetails.user.support_position ?? "",
                states: Userdetails.user.states ?? "",
                upload_verification_docs: Userdetails.user.upload_verification_docs ?? "",
                // benefit_enrollment_preferences: Userdetails.user.benefit_enrollment_preferences ?? "",
                digital_signature_of_acknowledgment: Userdetails.user.digital_signature_of_acknowledgment ?? "",
                business_name: Userdetails.user.business_name ?? "",
                ein: Userdetails.user.ein ?? "",
                facility_type: Userdetails.user.facility_type ?? "",
                staff_count: Userdetails.user.staff_count ?? "",
                service_type: Userdetails.user.service_type ?? "",
                message: Userdetails.user.message ?? "",
                role_id: Userdetails.user.role_id ?? ""
            });
            const benefits = Userdetails.user.benefit_enrollment_preferences || [];
            setSelectedBenefits(Array.isArray(benefits) ? benefits : [benefits]);

            setOriginalProfileImage(Userdetails.user.upload_verification_docs || null);

            setDisplayImage(Userdetails.user.upload_verification_docs || null);

        }
    }, [Userdetails]);


    const handleChange1 = (e) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle download dynamically per file
    const handleSubmit = (e) => {
        e.preventDefault();

        const updatedData = { ...form };
        if (
            !updatedData.upload_verification_docs ||
            (typeof updatedData.upload_verification_docs === "string" && updatedData.upload_verification_docs === originalProfileImage)
        ) {
            delete updatedData.upload_verification_docs;
        }
        const formData = new FormData();

        selectedBenefits.forEach((benefit) => {
            formData.append('benefit_enrollment_preferences[]', benefit);
        });

        Object.entries(form).forEach(([key, value]) => {
            if (value !== null && value !== "") {
                formData.append(key, value);
            }
        });



        dispatch(editProfile({ token, data: form }))
            .unwrap()
            .then(() => {
                toast.success("Profile Updated Successfully!");
                navigate("/panel/editprofile");
            })
            .catch(() => {
                toast.error("Failed to update profile");
            });
    };

    // if (loading || !Userdetails?.user) {
    //     return <p>Loading...</p>;
    // }

    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
            <div className="ps-2 ps-lg-4">
                <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                    Edit Profile
                </h4>

                {/* LOADING */}
                {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}

                {/* ERROR */}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-sm-6">
                                <label className="form-label text-primary mb-1 font-weight-semibold required">First Name</label>
                                <input
                                    type="text"
                                    name="first_name"
                                    className="form-control"
                                    onChange={handleChange}
                                    value={form.first_name}
                                />
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label text-primary mb-1 font-weight-semibold required">Last Name</label>
                                <input
                                    type="text"
                                    name="last_name"
                                    className="form-control"
                                    onChange={handleChange}
                                    value={form.last_name}
                                />
                            </div>
                            {(isRole4 || isRole56) && (
                                <>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Date Of Birth</label>
                                        <input
                                            type="date"
                                            name="date_of_birth"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={form.date_of_birth}
                                        />
                                    </div>
                                </>)}
                            <div className="col-sm-6">
                                <label className="form-label text-primary mb-1 font-weight-semibold required">Email</label>
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    onChange={handleChange}
                                    value={form.email}
                                />
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label text-primary mb-1 font-weight-semibold required">Phone</label>
                                <input
                                    type="text"
                                    name="phone"
                                    className="form-control"
                                    onChange={handleChange}
                                    value={form.phone}
                                />
                            </div>
                            {isRole3 && (
                                <>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Legal Business Name</label>
                                        <input
                                            type="text"
                                            name="business_name"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={form.business_name}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">EIN</label>
                                        <input
                                            type="text"
                                            name="ein"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={form.ein}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Facility Type</label>
                                        <select name="facility_type" class="form-select" required="" onChange={handleChange}>
                                            <option value="">Select Facility Type</option>
                                            <option selected={form.facility_type === "Home-based"} value="Home-based">Home-based</option>
                                            <option selected={form.facility_type === "Center"} value="Center">Center</option>
                                            <option selected={form.facility_type === "School-Age"} value="School-Age">School-Age</option>
                                        </select>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Staff Count</label>
                                        <input
                                            type="text"
                                            name="staff_count"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={form.staff_count}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Service Type</label>
                                        <select name="service_type" class="form-select" required="" onChange={handleChange}>
                                            <option value="">Select Service Type</option>
                                            <option selected={form.service_type === "Childcare"} value="Childcare">Childcare</option>
                                            <option selected={form.service_type === "Preschool"} value="Preschool">Preschool</option>
                                            <option selected={form.service_type === "After-school"} value="After-school">After-school</option>
                                            <option selected={form.service_type === "Other"} value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Message</label>
                                        <input
                                            type="text"
                                            name="message"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={form.message}
                                        />
                                    </div>

                                </>)}
                            {(isRole4 || isRole56) && (
                                <>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">
                                            Employment Type
                                        </label>
                                        <div className="d-flex mt-2">
                                            <div className="form-check me-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="employment_type"
                                                    id="fullTime"
                                                    value="Full-Time"
                                                    onChange={handleChange}
                                                    checked={form.employment_type === "Full-Time"}
                                                />
                                                <label className="form-check-label" htmlFor="fullTime">
                                                    Full-Time
                                                </label>
                                            </div>
                                            <div className="form-check me-3">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="employment_type"
                                                    id="partTime"
                                                    value="Part-Time"
                                                    onChange={handleChange}
                                                    checked={form.employment_type === "Part-Time"}
                                                />
                                                <label className="form-check-label" htmlFor="partTime">
                                                    Part-Time
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="job_type"
                                                    id="internship"
                                                    value="Internship"
                                                    onChange={handleChange}
                                                    checked={form.employment_type === "Internship"}
                                                />
                                                <label className="form-check-label" htmlFor="internship">
                                                    Internship
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            {isRole56 && (
                                <>
                                    {/* Worker Type */}
                                    {/* <div className="col-sm-6">
                            <label className="form-label text-primary mb-1 font-weight-semibold required">
                            Worker Type
                            </label>
                            <div className="d-flex mt-2">
                                <div className="form-check me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="worker_type"
                                        id="substitute_teacher"
                                        value="substitute_teacher"
                                        onChange={handleChange1}
                                        checked={form.worker_type === "substitute_teacher"}
                                    />
                                    <label className="form-check-label" htmlFor="fullTime">
                                    Teachers & Assistants
                                    </label>
                                </div>
                                <div className="form-check me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="worker_type"
                                        id="support_staffing"
                                        value="support_staffing"
                                        onChange={handleChange1}
                                        checked={form.worker_type === "support_staffing"}
                                    />
                                    <label className="form-check-label" htmlFor="partTime">
                                    Support Staffing Roles
                                    </label>
                                </div>
                            </div>
                        </div> */}
                                    {form.role_id === 5 && (
                                        <div className="col-sm-6">
                                            <label className="form-label text-primary mb-1 font-weight-semibold required">Select Category</label>
                                            <select class="form-select" name="teacher_position" onChange={handleChange}>
                                                <option value="">-- Select --</option>
                                                <option selected={form.teacher_position === 'Lead Teacher - Infant'} value="Lead Teacher - Infant">Lead Teacher - Infant</option>
                                                <option selected={form.teacher_position === 'Lead Teacher - Toddler'} value="Lead Teacher - Toddler">Lead Teacher - Toddler</option>
                                                <option selected={form.teacher_position === 'Lead Teacher - 2-Year-Olds'} value="Lead Teacher - 2-Year-Olds">Lead Teacher - 2-Year-Olds</option>
                                                <option selected={form.teacher_position === 'Lead Teacher - Preschool (3-5 yrs)'} value="Lead Teacher - Preschool (3-5 yrs)">Lead Teacher - Preschool (3-5 yrs)</option>
                                                <option selected={form.teacher_position === 'Assistant Teacher - Infant'} value="Assistant Teacher - Infant">Assistant Teacher - Infant</option>
                                                <option selected={form.teacher_position === 'Assistant Teacher - Toddler'} value="Assistant Teacher - Toddler">Assistant Teacher - Toddler</option>
                                                <option selected={form.teacher_position === 'Assistant Teacher - 2-Year-Olds'} value="Assistant Teacher - 2-Year-Olds">Assistant Teacher - 2-Year-Olds</option>
                                                <option selected={form.teacher_position === 'Assistant Teacher - Preschool (3-5 yrs)'} value="Assistant Teacher - Preschool (3-5 yrs)">Assistant Teacher - Preschool (3-5 yrs)</option>
                                            </select>
                                        </div>)}
                                    {form.role_id === 6 && (
                                        <div className="col-sm-6">
                                            <label className="form-label text-primary mb-1 font-weight-semibold required">Select Category</label>
                                            <select class="form-select" name="support_position" onChange={handleChange}>
                                                <option value="">-- Select --</option>
                                                <option selected={form.support_position === 'Clerical / Office Support'} value="Clerical / Office Support">Clerical / Office Support</option>
                                                <option selected={form.support_position === 'Cooks / Kitchen Staff'} value="Cooks / Kitchen Staff">Cooks / Kitchen Staff</option>
                                                <option selected={form.support_position === 'Janitorial Staff'} value="Janitorial Staff">Janitorial Staff</option>
                                                <option selected={form.support_position === 'Maintenance Staff'} value="Maintenance Staff">Maintenance Staff</option>
                                                <option selected={form.support_position === 'Custodians'} value="Custodians">Custodians</option>
                                                <option selected={form.support_position === 'Floaters / General Support Assistants'} value="Floaters / General Support Assistants">Floaters / General Support Assistants</option>
                                                <option selected={form.support_position === 'Afternoon Coverage Staff'} value="Afternoon Coverage Staff">Afternoon Coverage Staff</option>
                                                <option selected={form.support_position === 'Bus / Van Support (Future)'} value="Bus / Van Support (Future)">Bus / Van Support (Future)</option>
                                            </select>
                                        </div>)}
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Preferred Working States</label>
                                        <select class="form-select" name="states" required="" onChange={handleChange}>
                                            <option>Select stats</option>
                                            {stats.map(cat => (
                                                <option selected={form.states === cat.code} key={cat.id} value={cat.code}>{cat.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )}
                            {(isRole4 || isRole56) && (
                                <>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Upload Verification Docs (optional)</label>
                                        <input
                                            type="file"
                                            name="upload_verification_docs"
                                            className="form-control"
                                            onChange={handleChange}
                                            ref={fileInputRef}
                                        />
                                    </div>
                                    {/* Display Image */}
                                    {displayImage && typeof displayImage === 'string' && (
                                        <div className="text-md-end text-start">
                                            <div className="mb-2">
                                                <img
                                                    src={`${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${displayImage}`}
                                                    alt="Profile"
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">
                                            Benefit Enrollment Preferences (optional)
                                        </label>
                                        <div className="d-flex mt-2">
                                            <div className="form-check me-3">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="benefit_enrollment_preferences[]"
                                                    id="health"
                                                    value="Health"
                                                    onChange={handleCheckboxChange}
                                                    checked={selectedBenefits.includes("Health")}
                                                />
                                                <label className="form-check-label" htmlFor="health">
                                                    Health
                                                </label>
                                            </div>
                                            <div className="form-check me-3">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="benefit_enrollment_preferences[]"
                                                    id="dental"
                                                    value="Dental"
                                                    onChange={handleCheckboxChange}
                                                    checked={selectedBenefits.includes("Dental")}

                                                />downloadData
                                                <label className="form-check-label" htmlFor="dental">
                                                    Dental
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="benefit_enrollment_preferences[]"
                                                    id="retirement"
                                                    value="Retirement"
                                                    onChange={handleCheckboxChange}
                                                    checked={selectedBenefits.includes("Retirement")}
                                                />
                                                <label className="form-check-label" htmlFor="retirement">
                                                    Retirement
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Digital Signature of Acknowledgment (optional)</label>
                                        <input
                                            type="text"
                                            name="digital_signature_of_acknowledgment"
                                            className="form-control"
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            )}

                            <div className="col-12 mt-4">
                                <button
                                    type="submit"
                                    className="btn btn-light-header"
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : "Submit"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default WorkerEditProfile;
